import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import TwoFactor from './pages/TwoFactor/TwoFactor';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Businesses from './pages/Businesses';
import Vets from './pages/Vets';
import Reports from './pages/Reports';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Orders from './pages/Orders';
import Posts from './pages/Posts';
import MissingPets from './pages/MissingPets';
import DiscountCodes from './pages/DiscountCodes';
import AuditLog from './pages/AuditLog';
import Pets from './pages/Pets';
import VetBookings from './pages/VetBookings';
import Organizations from './pages/Organizations';
import Subscriptions from './pages/Subscriptions';
import Payments from './pages/Payments';
import Plans from './pages/Plans';
import AppSettingsPage from './pages/AppSettings';
import Sar from './pages/Sar';
import AiTraining from './pages/AiTraining';
import Marketing from './pages/Marketing';
import './styles/global.css';

const Spinner = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#0a0a0a',
  }}>
    <div className="spinner" />
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, pending2FA } = useAuth();

  if (loading) return <Spinner />;
  if (pending2FA) return <TwoFactor />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

// Public Route Component (redirects to dashboard if authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading, pending2FA } = useAuth();

  if (loading) return <Spinner />;
  if (pending2FA) return <TwoFactor />;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="pets" element={<Pets />} />
        <Route path="businesses" element={<Businesses />} />
        <Route path="vets" element={<Vets />} />
        <Route path="vet-bookings" element={<VetBookings />} />
        <Route path="ai-training" element={<AiTraining />} />
        <Route path="marketing" element={<Marketing />} />
        <Route path="organizations" element={<Organizations />} />
        <Route path="orders" element={<Orders />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="payments" element={<Payments />} />
        <Route path="plans" element={<Plans />} />
        <Route path="posts" element={<Posts />} />
        <Route path="missing-pets" element={<MissingPets />} />
        <Route path="reports" element={<Reports />} />
        <Route path="sar" element={<Sar />} />
        <Route path="discount-codes" element={<DiscountCodes />} />
        <Route path="audit-log" element={<AuditLog />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="app-settings" element={<AppSettingsPage />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
